import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { drapcodeIcon } from '../../common/custom/icon-library';
import { REST_API } from 'drapcode-constant';
export class WebHookHeaderNav extends Component {
  render() {
    const { activeTab, projectId, title, icon, version } = this.props;
    return (
      <div className="container webhook">
        <nav className="navbar navbar-expand-lg bg-primary">
          <div className="container">
            <div className="navbar-translate">
              <div className="navbar-brand">
                <i className={`wb ${drapcodeIcon(icon)}`} size={'md'}></i>&nbsp;
                <span>{title}</span>
              </div>
            </div>
            <div className="collapse navbar-collapse">
              <ul className="navbar-nav ml-auto">
                <li className={`nav-item ${activeTab === REST_API && 'active'}`}>
                  <Link to={`/webhook/${version}/v/${projectId}/`} className="nav-link">
                    <span className="circle">
                      <i
                        className={`wb ${drapcodeIcon(icon)}`}
                        size={'md'}
                        style={{ color: '#303453' }}
                      ></i>
                    </span>
                    &nbsp;{title}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}
export default WebHookHeaderNav;
